module.exports = __webpack_public_path__ + "media/images/countryrect/aw-6df446a15bfe5504cc7ba969cd3a2dcf.svg";